// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-pointer {
  cursor: pointer;
}

.cursor-pointer:hover {
  opacity: 0.7;
}

.evaluacion-riesgos-container {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
}

.fase-container {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  background-color: white;
}

.nivel-riesgo-menor {
  background-color: #28a745 !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.nivel-riesgo-moderado {
  background-color: #ffc107 !important;
  color: black !important;
  font-weight: bold;
  text-align: center;
}

.nivel-riesgo-alto {
  background-color: #fd7e14 !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.nivel-riesgo-urgente {
  background-color: #dc3545 !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

.nivel-riesgo-extremo {
  background-color: #6f42c1 !important;
  color: white !important;
  font-weight: bold;
  text-align: center;
}

/* Estilos específicos para inputs de riesgo */
input[id^='riesgo-'] {
  background-color: #f8f9fa !important;
  text-align: center;
  font-weight: bold;
}

input[id^='nivelRiesgo-'] {
  text-align: center;
  font-weight: bold;
  color: white;
}

/* Estilos dinámicos para nivel de riesgo basados en valor */
input[id^='nivelRiesgo-'][value='MENOR'] {
  background-color: #28a745 !important;
  color: white !important;
}

input[id^='nivelRiesgo-'][value='MODERADO'] {
  background-color: #ffc107 !important;
  color: black !important;
}

input[id^='nivelRiesgo-'][value='ALTO'] {
  background-color: #fd7e14 !important;
  color: white !important;
}

input[id^='nivelRiesgo-'][value='URGENTE'] {
  background-color: #dc3545 !important;
  color: white !important;
}

input[id^='nivelRiesgo-'][value='EXTREMO'] {
  background-color: #6f42c1 !important;
  color: white !important;
}

.table-peligros th {
  background-color: #e9ecef;
  font-weight: 600;
  font-size: 0.875rem;
  text-align: center;
  vertical-align: middle;
}

.table-peligros td {
  vertical-align: middle;
  font-size: 0.875rem;
}

.form-label {
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.riesgo-calculation {
  background-color: #f1f3f4;
  border-radius: 6px;
  padding: 1rem;
  margin-top: 1rem;
}

.nueva-fase-input {
  width: 300px;
}

.fase-numero-input {
  width: 60px;
  text-align: center;
}

.fase-numero-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
}

.fase-numero-container .form-label {
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  font-weight: 600;
}

/* Estilos para el modal de peligro */
.modal-peligro-form {
  max-width: 100%;
}

.modal-peligro-form .form-label {
  font-weight: 600;
  color: #495057;
}

.modal-peligro-form .form-control {
  border-radius: 4px;
  border: 1px solid #ced4da;
}

.modal-peligro-form .form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.barrera-mitigacion {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
}

.barrera-mitigacion h6 {
  color: #495057;
  font-weight: 600;
  margin-bottom: 1rem;
}

.select-peligro {
  font-size: 1rem;
}

/* Estilos para campos en modo visualización */
.modal-peligro-form input:disabled,
.modal-peligro-form select:disabled {
  background-color: #f8f9fa !important;
  border-color: #e9ecef !important;
  color: #6c757d !important;
  opacity: 1 !important;
}

.modal-peligro-form .barrera-mitigacion input:disabled {
  background-color: #ffffff !important;
  border-color: #dee2e6 !important;
  color: #495057 !important;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Pages/Solicitud/AnalisisRiesgo/EvaluacionRiesgosPersonales/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA,4DAA4D;AAC5D;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;;EAEE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B","sourcesContent":[".cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-pointer:hover {\n  opacity: 0.7;\n}\n\n.evaluacion-riesgos-container {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.fase-container {\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  background-color: white;\n}\n\n.nivel-riesgo-menor {\n  background-color: #28a745 !important;\n  color: white !important;\n  font-weight: bold;\n  text-align: center;\n}\n\n.nivel-riesgo-moderado {\n  background-color: #ffc107 !important;\n  color: black !important;\n  font-weight: bold;\n  text-align: center;\n}\n\n.nivel-riesgo-alto {\n  background-color: #fd7e14 !important;\n  color: white !important;\n  font-weight: bold;\n  text-align: center;\n}\n\n.nivel-riesgo-urgente {\n  background-color: #dc3545 !important;\n  color: white !important;\n  font-weight: bold;\n  text-align: center;\n}\n\n.nivel-riesgo-extremo {\n  background-color: #6f42c1 !important;\n  color: white !important;\n  font-weight: bold;\n  text-align: center;\n}\n\n/* Estilos específicos para inputs de riesgo */\ninput[id^='riesgo-'] {\n  background-color: #f8f9fa !important;\n  text-align: center;\n  font-weight: bold;\n}\n\ninput[id^='nivelRiesgo-'] {\n  text-align: center;\n  font-weight: bold;\n  color: white;\n}\n\n/* Estilos dinámicos para nivel de riesgo basados en valor */\ninput[id^='nivelRiesgo-'][value='MENOR'] {\n  background-color: #28a745 !important;\n  color: white !important;\n}\n\ninput[id^='nivelRiesgo-'][value='MODERADO'] {\n  background-color: #ffc107 !important;\n  color: black !important;\n}\n\ninput[id^='nivelRiesgo-'][value='ALTO'] {\n  background-color: #fd7e14 !important;\n  color: white !important;\n}\n\ninput[id^='nivelRiesgo-'][value='URGENTE'] {\n  background-color: #dc3545 !important;\n  color: white !important;\n}\n\ninput[id^='nivelRiesgo-'][value='EXTREMO'] {\n  background-color: #6f42c1 !important;\n  color: white !important;\n}\n\n.table-peligros th {\n  background-color: #e9ecef;\n  font-weight: 600;\n  font-size: 0.875rem;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.table-peligros td {\n  vertical-align: middle;\n  font-size: 0.875rem;\n}\n\n.form-label {\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.riesgo-calculation {\n  background-color: #f1f3f4;\n  border-radius: 6px;\n  padding: 1rem;\n  margin-top: 1rem;\n}\n\n.nueva-fase-input {\n  width: 300px;\n}\n\n.fase-numero-input {\n  width: 60px;\n  text-align: center;\n}\n\n.fase-numero-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 80px;\n}\n\n.fase-numero-container .form-label {\n  margin-bottom: 0.25rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n/* Estilos para el modal de peligro */\n.modal-peligro-form {\n  max-width: 100%;\n}\n\n.modal-peligro-form .form-label {\n  font-weight: 600;\n  color: #495057;\n}\n\n.modal-peligro-form .form-control {\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n}\n\n.modal-peligro-form .form-control:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.barrera-mitigacion {\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 1rem;\n}\n\n.barrera-mitigacion h6 {\n  color: #495057;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.select-peligro {\n  font-size: 1rem;\n}\n\n/* Estilos para campos en modo visualización */\n.modal-peligro-form input:disabled,\n.modal-peligro-form select:disabled {\n  background-color: #f8f9fa !important;\n  border-color: #e9ecef !important;\n  color: #6c757d !important;\n  opacity: 1 !important;\n}\n\n.modal-peligro-form .barrera-mitigacion input:disabled {\n  background-color: #ffffff !important;\n  border-color: #dee2e6 !important;\n  color: #495057 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
